import React, { useContext } from 'react';
import moment from 'moment';
import { Input } from 'antd';

import { UserInfoStore } from '@src/store/UserInfoData/Provider';
import useGetLang from '@src/utils/hooks/useGetLang';

// 根据语言显示不同格式时间
export const TimeTranslateCom = ({ value = '' }) => {
  const { state } = useContext(UserInfoStore);

  const getLang = state?.userInfo?.language || 'en_US';
  
  if (value?.split(':')?.length > 1) {
    switch (getLang) {
      case 'en_US':
        return <span>{!!value ? moment(value).format('MMMM DD YYYY HH:mm:ss') : ''}</span>
      case 'zh_CN':
        return <span>{!!value ? moment(value).format('YYYY/MM/DD HH:mm:ss') : ''}</span>
      case 'zh_XG':
        return <span>{!!value ? moment(value).format('YYYY/MM/DD HH:mm:ss') : ''}</span>
      default:
        return <span>{!!value ? moment(value).format('MMMM DD YYYY HH:mm:ss') : ''}</span>
    }
  }

  if (value?.split('-')?.length === 2) {
    switch (getLang) {
      case 'en_US':
        return <span>{!!value ? moment(value).format('MMMM YYYY') : ''}</span>
      case 'zh_CN':
        return <span>{!!value ? moment(value).format('YYYY/MM') : ''}</span>
      case 'zh_XG':
        return <span>{!!value ? moment(value).format('YYYY/MM') : ''}</span>
      default:
        return <span>{!!value ? moment(value).format('MMMM YYYY') : ''}</span>
    }
  }

  switch (getLang) {
    case 'en_US':
      return <span>{!!value ? moment(value).format('MMMM DD YYYY') : ''}</span>
    case 'zh_CN':
      return <span>{!!value ? moment(value).format('YYYY/MM/DD') : ''}</span>
    case 'zh_XG':
      return <span>{!!value ? moment(value).format('YYYY/MM/DD') : ''}</span>
    default:
      return <span>{!!value ? moment(value).format('MMMM DD YYYY') : ''}</span>
  }
};

// 根据语言显示不同格式时间 Input 组件
export const TimeTranslateInput = (props) => {
  const { state } = useContext(UserInfoStore);

  const getLang = state?.userInfo?.language || 'en_US';
  
  const inputVal = () => {
    switch (getLang) {
      case 'en_US':
        return !!props.value ? moment(props.value).format('MMMM DD YYYY HH:mm:ss') : ''
      case 'zh_CN':
        return !!props.value ? moment(props.value).format('YYYY/MM/DD HH:mm:ss') : ''
      case 'zh_XG':
        return !!props.value ? moment(props.value).format('YYYY/MM/DD HH:mm:ss') : ''
      default:
        return !!props.value ? moment(props.value).format('MMMM DD YYYY HH:mm:ss') : ''
    }
  }

  return <Input
    {...props}
    value={inputVal()}
  />
}